export const defaultBackgroundColor = '#FFFFFF';
export const defaultBackgroundRepeat = 'repeat';
export const defaultContainerElements = [
    'ul',
    'li',
    'h1',
    'h2',
    'h3',
    'p',
    'span',
];
export const defaultDividerName = 'divider1';
export const defaultDividerRole = 'divider';
export const defaultLineHeight = 1;
export const defaultLink = 'https://wix.com';
export const defaultTextColor = '#000000';
export const defaultTextPadding = '18px';
export const defaultTextSize = 14;
export const defaultInputFieldColor = '#858585';
export const defaultInputFieldBorderColor = '#ccc';
export const defaultBreakpoint = '480px';
export const defaultButtonPadding = '10px 25px';
export const defaultButtonPaddingObject = {
    top: '10px',
    right: '25px',
    bottom: '10px',
    left: '25px',
};
export const buttonMobileBreakpoints = [
    '480px',
    '420px',
    '400px',
    '360px',
    '320px',
];
export const mobileFullWidthColumnClassName = 'html-column-mobile-full-width';
export const mobileNoWrapColumnClassName = 'html-column-width-mobile-no-wrap';
export const defaults = {
    defaultBackgroundColor,
    defaultBackgroundRepeat,
    defaultContainerElements,
    defaultDividerName,
    defaultDividerRole,
    defaultLineHeight,
    defaultLink,
    defaultTextColor,
    defaultTextPadding,
    defaultTextSize,
    defaultBreakpoint,
    defaultButtonPadding,
    defaultButtonPaddingObject,
    buttonMobileBreakpoints,
    mobileFullWidthColumnClassName,
    mobileNoWrapColumnClassName,
};
//# sourceMappingURL=defaults.js.map